import { render, staticRenderFns } from "./RoomPasswordEditDialog.vue?vue&type=template&id=b5d7afea&lang=pug&"
import script from "./RoomPasswordEditDialog.vue?vue&type=script&lang=js&"
export * from "./RoomPasswordEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomPasswordEditDialog.vue"
export default component.exports